import React, { Fragment } from 'react';
import { Popconfirm } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import H3Text from '../../../../../uilib/h3Text';

function ViewOutgoingPaymentHeader({
  selectedPaymentOutgoing,
  user,
  isQuickView,
  paymentType,
  callback,
  updatePaymentsOutgoingStatus,
  updatePaymentsOutgoingStatusLoading,
  currentUpdate,
  setCurrentUpdate,
}) {
  return (
    <Fragment>
      <div className="view-document__title">
        <div className="view-document__title-number-wrapper">
          <H3Text text={`#${selectedPaymentOutgoing?.payment_id}`} className="view-document__title-number" />
          <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPaymentOutgoing?.approval_status).color }}>
            {selectedPaymentOutgoing?.approval_status?.replaceAll('_', ' ')}
          </div>
        </div>
        {!isQuickView && paymentType !== 'DEBIT_NOTE' && (
          <div className="view-document__title-actions">
            <div className="action-buttons">
              {selectedPaymentOutgoing?.approval_status !== 'CANCELLED' && selectedPaymentOutgoing?.payment_type !== 'INCOMING'
                && Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT,
                  Helpers.permissionTypes.UPDATE, user) && (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure you want to cancel this payment?"
                    onConfirm={() => {
                      setCurrentUpdate('CANCELLED');
                      updatePaymentsOutgoingStatus({
                        payment_id: selectedPaymentOutgoing?.payment_id,
                        tenant_id: selectedPaymentOutgoing?.tenant_seller_info?.tenant_id ?? selectedPaymentOutgoing?.tenant_id,
                        status: 'CANCELLED',
                      }, () => {
                        setCurrentUpdate('');
                        callback();
                      });
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <H3Text
                      text={(
                        <Fragment>
                          {(currentUpdate === 'CANCELLED' && updatePaymentsOutgoingStatusLoading)
                            ? <LoadingOutlined /> : (
                              <Fragment>Cancel</Fragment>
                            )}
                        </Fragment>
                      )}
                      className="action-button action-button-big action-button-payment"
                    />
                  </Popconfirm>
                )}

              {((!['PAYMENT_STARTED', 'PAYMENT_PROCESSING', 'PAYMENT_SUCCESS'].includes(selectedPaymentOutgoing.payment_status)) || selectedPaymentOutgoing?.payment_type === 'INCOMING') && Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT,
                Helpers.permissionTypes.DELETE, user) && (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure you want to delete this payment permanently?"
                    onConfirm={() => {
                      setCurrentUpdate('DELETE');
                      const payload = {
                        payment_id: selectedPaymentOutgoing?.payment_id,
                        tenant_id: selectedPaymentOutgoing?.tenant_seller_info?.tenant_id ?? selectedPaymentOutgoing?.tenant_id,
                        status: 'DELETED',
                      };
                      updatePaymentsOutgoingStatus(payload, () => {
                        setCurrentUpdate('');
                        // pendo.track('DELETE_PAYMENT', payload);
                        callback();
                      });
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <H3Text
                      text={(
                        <Fragment>
                          {(currentUpdate === 'DELETE' && updatePaymentsOutgoingStatusLoading)
                            ? <LoadingOutlined /> : (
                              <Fragment>Delete</Fragment>
                            )}
                        </Fragment>
                      )}
                      className="action-button action-button-big action-button-payment"
                    />
                  </Popconfirm>
                )}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default ViewOutgoingPaymentHeader;
